import { API_URL } from 'utils/constants/app';
import { queryStringFromDict, RequestHelper } from 'utils/helpers/RequestHelper';

const companyServiceUrl = `${API_URL}/companies`;

const getCompanies = ({isEcc, isLabo}) => RequestHelper.GET(`${companyServiceUrl}?${
  queryStringFromDict({isEcc, isLabo})
}`);

const getAllCompanies = () => RequestHelper.GET(`${companyServiceUrl}/selectItems/all`);

export const CompanyService = {
  getAllCompanies,
  getCompanies
};